"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHistory = getHistory;
exports.setHistory = setHistory;
/**
 * Holds the application HashHistory or BrowserHistory
 */

var history;

function getHistory() {
  return history;
}

function setHistory(value) {
  history = value;
  return history;
}